require('./src/style.less')

console.log("French loaded.")

// addEventListener('DOMContentLoaded', function() {
//   let subnav = document.querySelector('.subnav')
//   if(subnav) {
//     let mainbarHeight = 60
//     let subbarPosition = 999
//     let fixed = false
//     let maxwidth = 1080
//
//     addEventListener('load', function() {
//       // wait until all images and assets are loaded.
//       subbarPosition = subnav.offsetTop
//
//     })
//
//
//     window.addEventListener('scroll', function (e) {
//       if (this.scrollY > subbarPosition - 60 && !fixed) {
//         subnav.classList.add('scrolled')
//         document.body.classList.add('sub-nav-scrolled')
//         fixed = true
//         console.log("FIX")
//       } else if(this.scrollY < subbarPosition - 60 && fixed) {
//         subnav.classList.remove('scrolled')
//         document.body.classList.remove('sub-nav-scrolled')
//         fixed = false
//         console.log("UNFIX")
//       }
//     }, false)
//   }
// })



// WEBPACK FOOTER //
// ./theme/micro-french/index.js